// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20Rdh","controls":"styles_controls__3iEG4","charLimit":"styles_charLimit__3_RDn","input":"styles_input__qZcs7","send":"styles_send__3xfBz"};